import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { useCompany } from "../components/context/CompanyContext";
import { SidebarProvider, useSidebar } from "./context/SidebarContext";
import RequireScreenAccess from "./RequireScreenAccess";
import SidebarComponent from "./SidebarComponent";
import Topbar from "./Topbar";

const hasUser = (user) => user && Object.keys(user).length > 0;

function LayoutInner() {
  const { collapsed } = useSidebar();
  const currentUser = useSelector((state) => state.user.currentUser);
  const currentSlug = useSelector((state) => state.urlRef.currentSlug);

  useCompany();

  useEffect(() => {
    if (!currentUser || !currentSlug?.slug) return; // aguarda tudo carregar

    const [, rootParam] = window.location.pathname.split("/");

    if (rootParam && rootParam !== currentSlug.slug) {
      localStorage.clear();
      window.location.href = `/${rootParam}/login`;
    }
  }, [currentUser, currentSlug]);

  return (
    <div className={`wrapper ${collapsed ? "" : "wrapper--expanded"}`}>
      {hasUser(currentUser) && (
        <header>
          <Topbar />
        </header>
      )}

      <article>
        <RequireScreenAccess>
          <Outlet />
        </RequireScreenAccess>
      </article>

      {hasUser(currentUser) && (
        <aside>
          <SidebarComponent />
        </aside>
      )}
    </div>
  );
}

export default function Layout() {
  return (
    <SidebarProvider>
      <LayoutInner />
    </SidebarProvider>
  );
}
